import { render } from "./NewCustomers.vue?vue&type=template&id=4265c223&scoped=true&ts=true"
import script from "./NewCustomers.vue?vue&type=script&lang=ts"
export * from "./NewCustomers.vue?vue&type=script&lang=ts"

import "./NewCustomers.vue?vue&type=style&index=0&id=4265c223&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4265c223"]])

export default __exports__